import { RootState } from "@/store/types";
import { GetterTree } from "vuex";
import { NavigationState } from "./types";

export const getters: GetterTree<NavigationState, RootState> = {
  currentId(state): string {
    return state.currentId;
  },
  isMobile(): boolean {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  },
  darkMode(state): boolean {
    const theme = state.display.theme;
    if (theme.mode === "unset") {
      return theme.os === "dark";
    } else {
      return theme.mode === "dark";
    }
  },
  inWrapper(state): boolean {
    return state.inWrapper;
  },
  helpStep(state): number {
    return state.helpStep;
  },
  showLegendMobile(state): boolean {
    return state.display.showLegendMobile;
  },
  openedWindows(state) {
    return state.openWindows;
  },
  route(_state, _getters, rootState) {
    return rootState.route;
  },
  redirectTo(state) {
    return state.redirectTo;
  },
  censusPreferences(state) {
    return state.censusPreferences;
  },
  mobilePage(state) {
    return state.mobilePage;
  },
  routeHistory(state) {
    return state.routeHistory;
  },
  staticTitle(state) {
    return state.staticTitle;
  }
};
